import {http} from './index';
import {IFeedbackRecord} from '@types';
// 收集反馈列表项目获取
export const bookingProject = () => http.get('/teaching-workbench/booking/v2/booking-project');
// 收集反馈列表项目获取
export const bookingTeam = () => http.get('/teaching-workbench/booking/v2/booking-team');

// 收集反馈列表
export const feedbackRecord = (params: IFeedbackRecord) => http.post('/teaching-workbench/booking/member-feedback/time-record/page',params);
// 获取学员列表
export const getStudentList = (params:{name:string}) => http.post('/olaf/member/detail-list',params);
// 导出
export const feedbackQaExport = (params: IFeedbackRecord) => http.post('/teaching-workbench/booking/member-feedback/time-record/export', params, { responseType: 'blob'});
